import type { AdminSaleLine, SaleItem } from '../api/admin.api'

export type AdminChargeType = NonNullable<SaleItem['chargeType']>

export function adminSaleOriginId(saleId: string): string | undefined {
  if (!saleId.startsWith('funnel:')) return undefined
  const parts = saleId.split(':')
  return parts.length >= 3 && parts[1] ? parts[1] : undefined
}

export function adminJourneyId(sale: SaleItem): string {
  return sale.journeyId ?? sale.originSaleId ?? adminSaleOriginId(sale.id) ?? sale.id
}

export function adminChargeType(sale: SaleItem): AdminChargeType {
  if (sale.chargeType) return sale.chargeType
  if (sale.isRenewal) return 'RENEWAL'
  if (!sale.id.startsWith('funnel:')) return 'CHECKOUT'
  const node = sale.id.split(':')[2]?.toLocaleLowerCase('pt-BR') ?? ''
  if (node.startsWith('downsell')) return 'DOWNSELL'
  if (node.startsWith('upsell')) return 'UPSELL'
  return 'FUNNEL'
}

function renewalCycle(sale: SaleItem): number | undefined {
  if (!sale.id.startsWith('invoice:')) return undefined
  const cycle = Number(sale.id.slice(sale.id.lastIndexOf(':') + 1))
  return Number.isInteger(cycle) && cycle > 0 ? cycle : undefined
}

export function adminChargeLabel(sale: SaleItem): string {
  const type = adminChargeType(sale)
  if (type === 'UPSELL') return 'Upsell'
  if (type === 'DOWNSELL') return 'Downsell'
  if (type === 'FUNNEL') return 'Etapa de funil'
  if (type === 'RENEWAL') {
    const cycle = renewalCycle(sale)
    return cycle ? `Renovação · ciclo ${cycle}` : 'Renovação'
  }
  return 'Cobrança inicial'
}

export function adminProductLabel(sale: SaleItem): string {
  return sale.productName?.trim() || `Produto ${sale.productId}`
}

export function adminSaleLineProductLabel(line: AdminSaleLine): string {
  return line.productName?.trim() || `Produto ${line.productId}`
}

export function adminSaleLineOfferLabel(line: AdminSaleLine): string | null {
  const offerName = line.offerName?.trim()
  return offerName && offerName !== line.productName?.trim() ? offerName : null
}
